import { Header, MappingSuggestion } from '@/models/dataSource';

export const MAPPING_SUGGESTIONS_TIMEOUT_MS = 5000;

const CONFIDENT_SUGGESTION_SOURCES = new Set(['MEMORY', 'DICTIONARY', 'PATTERN']);

/** PROPOSAL and any unknown future source (e.g. AI) should show the verify hint. */
export const isProposalSource = (source?: string) => Boolean(source) && !CONFIDENT_SUGGESTION_SOURCES.has(source);

export const toColumnMapFileKey = (workspaceId: string, headers: string[], samples: string[][]) => {
  if (headers.length === 0) return '';

  return `${workspaceId}\u0000${headers.join('\u0000')}\u0000${samples.map((row) => row.join('\u0001')).join('\u0002')}`;
};

export type AppliedMappingSuggestions = {
  headers: Header[];
  sources: string[];
};

/** Returns applied suggestions when the payload matches header length; otherwise null (local fallback). */
export const applyMappingSuggestions = (
  suggestions: MappingSuggestion[] | undefined | null,
  headersLength: number
): AppliedMappingSuggestions | null => {
  if (!Array.isArray(suggestions) || suggestions.length !== headersLength) {
    return null;
  }

  return {
    headers: suggestions.map((suggestion) => suggestion.mapping),
    sources: suggestions.map((suggestion) => suggestion.source),
  };
};
